import apiHelper from "@/webapi/api_helper"
import logger from "@/util/logger"

// apis
const TARGET_API = 'diagnostics-service';
const API_TEST = 'test';
// params
const PARAM_PROVIDER_ACCOUNT_ID = 'providerAccountId';
const PARAM_HOUSE_NUMBER = 'houseNumber';
const PARAM_ACCOUNT_NUMBER = 'accountNumber';
const PARAM_SKIP_ONT = 'skipOnt';

const LOG_TAG = 'diagnostic_service';
export default {
  getLastDiagnosticsResultByAccountId(accountId, onResponseCb, onErrorCb) {
    const url = apiHelper.createUrl(TARGET_API, API_TEST);
    const queryParams = apiHelper.createParams(
      PARAM_PROVIDER_ACCOUNT_ID, accountId
    );
    const urlWithParams = `${url}${queryParams}`;

    logger.d(LOG_TAG, 'getLastDiagnosticsResultByAccountId', urlWithParams);
    apiHelper.apiGet(urlWithParams, onResponseCb, onErrorCb);
  },
  getLastDiagnosticsResultByHouseAndAccountNumber(houseNum, accountNum, onResponseCb, onErrorCb) {
    const url = apiHelper.createUrl(TARGET_API, API_TEST);
    const queryParams = apiHelper.createParams(
      PARAM_HOUSE_NUMBER, houseNum,
      PARAM_ACCOUNT_NUMBER, accountNum,
    );
    const urlWithParams = `${url}${queryParams}`;

    logger.d(LOG_TAG, 'getLastDiagnosticsResultByHouseAndAccountNumber', urlWithParams);
    apiHelper.apiGet(urlWithParams, onResponseCb, onErrorCb);
  },
  startDiagnosticsByAccountId(accountId, skipOnt, onResponseCb, onErrorCb) {
    let url = apiHelper.createUrl(
      TARGET_API, API_TEST,
      apiHelper.createParams(
        PARAM_PROVIDER_ACCOUNT_ID, accountId,
        PARAM_SKIP_ONT, skipOnt,
      )
    );
    logger.d(LOG_TAG, 'startDiagnosticsByAccountId', url);
    apiHelper.apiPost(url, {}, onResponseCb, onErrorCb);
  },
  startDiagnosticsByHouseAndAccountNumber(houseNumber, accountNumber, skipOnt, onResponseCb, onErrorCb) {
    let url = apiHelper.createUrl(
      TARGET_API, API_TEST,
      apiHelper.createParams(
        PARAM_HOUSE_NUMBER, houseNumber,
        PARAM_ACCOUNT_NUMBER, accountNumber,
        PARAM_SKIP_ONT, skipOnt,
      )
    );
    logger.d(LOG_TAG, 'startDiagnosticsByHouseAndAccountNumber', url);
    apiHelper.apiPost(url, {}, onResponseCb, onErrorCb);
  },

};

